// Copyright (c) Docugami, Inc. All rights reserved.

import { useAppInsightsContext, useTrackMetric } from "@microsoft/applicationinsights-react-js";
import { useEffect } from "react";

/**
 * Hook for exposing a function used to track component usage metrics.
 * Simply calling the function will aggregate and batch usage accordingly.
 */
export function useComponentUsageMetrics(name: string): () => void {
    const appInsights = useAppInsightsContext();
    const trackComponent = useTrackMetric(appInsights, name);

    useEffect(() => {
        trackComponent();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

    return trackComponent;
}
